(function () {
  if (typeof window === "undefined" || !window.EZINKArtCheck) return;
  var Check = window.EZINKArtCheck;

  var pdfJsLoading = null;

  function loadPdfJs() {
    if (window.pdfjsLib) return Promise.resolve(window.pdfjsLib);
    if (pdfJsLoading) return pdfJsLoading;
    pdfJsLoading = new Promise(function (resolve, reject) {
      var s = document.createElement("script");
      s.src = "https://cdnjs.cloudflare.com/ajax/libs/pdf.js/3.11.174/pdf.min.js";
      s.onload = function () {
        window.pdfjsLib.GlobalWorkerOptions.workerSrc =
          "https://cdnjs.cloudflare.com/ajax/libs/pdf.js/3.11.174/pdf.worker.min.js";
        resolve(window.pdfjsLib);
      };
      s.onerror = function () {
        pdfJsLoading = null;
        reject(new Error("Could not load PDF preview"));
      };
      document.head.appendChild(s);
    });
    return pdfJsLoading;
  }

  function fileTooBig(file) {
    return file && file.size > Check.MAX_BYTES;
  }

  function showStatus(el, msg, isError) {
    if (!el) return;
    el.hidden = false;
    el.textContent = msg;
    el.classList.toggle("is-error", !!isError);
  }

  function parseAttached(line) {
    var props = {};
    line.querySelectorAll(".ezink-art__attached li").forEach(function (li) {
      var strong = li.querySelector("strong");
      if (!strong) return;
      var key = strong.textContent.replace(/:\s*$/, "").trim();
      var link = li.querySelector("a");
      var val = link ? link.getAttribute("href") : (li.textContent.split(":").slice(1).join(":") || "").trim();
      if (key && val) props[key] = val;
    });
    return props;
  }

  function ensureModal() {
    var modal = document.getElementById("ezink-art-modal");
    if (modal) return modal;
    modal = document.createElement("div");
    modal.id = "ezink-art-modal";
    modal.className = "ezink-art-modal";
    modal.hidden = true;
    modal.innerHTML =
      '<div class="ezink-art-modal__backdrop" data-ezink-modal-close></div>' +
      '<div class="ezink-art-modal__dialog" role="dialog" aria-modal="true" aria-label="Artwork preview">' +
      '<button type="button" class="ezink-art-modal__close" data-ezink-modal-close aria-label="Close">&times;</button>' +
      '<div class="ezink-art-modal__body"></div></div>';
    document.body.appendChild(modal);
    modal.addEventListener("click", function (e) {
      if (e.target.closest("[data-ezink-modal-close]")) closeModal();
    });
    document.addEventListener("keydown", function (e) {
      if (e.key === "Escape") closeModal();
    });
    return modal;
  }

  function openModal(html) {
    var modal = ensureModal();
    modal.querySelector(".ezink-art-modal__body").innerHTML = html;
    modal.hidden = false;
    document.body.style.overflow = "hidden";
  }

  function closeModal() {
    var modal = document.getElementById("ezink-art-modal");
    if (!modal) return;
    modal.hidden = true;
    modal.querySelector(".ezink-art-modal__body").innerHTML = "";
    document.body.style.overflow = "";
  }

  function inspectImage(src) {
    return new Promise(function (resolve) {
      var img = new Image();
      img.onload = function () {
        resolve({ width: img.naturalWidth, height: img.naturalHeight, previewUrl: src });
      };
      img.onerror = function () { resolve(null); };
      img.src = src;
    });
  }

  function inspectPdf(src, file) {
    return loadPdfJs()
      .then(function (pdfjsLib) {
        if (file) {
          return file.arrayBuffer().then(function (buf) {
            return pdfjsLib.getDocument({ data: new Uint8Array(buf) }).promise;
          });
        }
        return pdfjsLib.getDocument({ url: src, withCredentials: false }).promise;
      })
      .then(function (pdf) {
        return pdf.getPage(1).then(function (page) {
          var vp = page.getViewport({ scale: 1 });
          var canvas = document.createElement("canvas");
          var scale = Math.min(1.5, 720 / Math.max(vp.width, vp.height));
          var draw = page.getViewport({ scale: scale });
          canvas.width = draw.width;
          canvas.height = draw.height;
          return page
            .render({ canvasContext: canvas.getContext("2d"), viewport: draw })
            .promise.then(function () {
              return {
                widthIn: vp.width / 72,
                heightIn: vp.height / 72,
                pages: pdf.numPages,
                previewUrl: canvas.toDataURL("image/jpeg", 0.72)
              };
            });
        });
      })
      .catch(function () { return null; });
  }

  function inspectSource(opts) {
    var name = opts.name || (opts.file && opts.file.name) || "artwork";
    var bytes = opts.bytes != null ? opts.bytes : (opts.file ? opts.file.size : 0);
    var spec = opts.spec || Check.specFromProduct({});
    var meta = Check.checkFileMeta(name, bytes);
    var issues = meta.issues.slice();
    var ext = meta.ext;
    var src = opts.url;
    var revoke = null;
    if (opts.file) {
      src = URL.createObjectURL(opts.file);
      revoke = src;
    }
    var result = {
      name: name,
      bytes: bytes,
      ext: ext,
      spec: spec,
      issues: issues,
      previewUrl: "",
      previewKind: "none",
      widthPx: 0,
      heightPx: 0,
      pages: 0,
      label: opts.label || "Artwork"
    };

    function finish(extraIssues) {
      if (extraIssues && extraIssues.length) result.issues = result.issues.concat(extraIssues);
      result.ok = !Check.hasWarn(result.issues);
      result.summary = Check.summary(result.issues);
      return result;
    }

    if (!src || Check.NO_PREVIEW[ext]) return Promise.resolve(finish());

    if (ext === "pdf") {
      return inspectPdf(src, opts.file).then(function (info) {
        if (revoke) URL.revokeObjectURL(revoke);
        if (!info) {
          result.previewKind = "embed";
          result.previewUrl = opts.url || "";
          return finish();
        }
        result.previewKind = "image";
        result.previewUrl = info.previewUrl;
        result.pages = info.pages;
        return finish(Check.checkPdfPage(info.widthIn, info.heightIn, info.pages, spec));
      });
    }

    if (ext === "svg" || ext === "png" || ext === "jpg" || ext === "jpeg" || ext === "webp" || ext === "gif") {
      return inspectImage(src).then(function (info) {
        if (!info) {
          if (revoke) URL.revokeObjectURL(revoke);
          return finish();
        }
        result.previewKind = "image";
        result.previewUrl = info.previewUrl;
        result.widthPx = info.width;
        result.heightPx = info.height;
        return finish(Check.checkRaster(info.width, info.height, spec));
      });
    }

    if (revoke) URL.revokeObjectURL(revoke);
    return Promise.resolve(finish());
  }

  function renderCard(result) {
    var warn = Check.hasWarn(result.issues);
    var errors = (result.issues || []).filter(function (i) { return i.level === "error"; });
    var badge = errors.length ? "error" : warn ? "warn" : "ok";
    var badgeText = errors.length ? "Can’t use this file" : warn ? "Out of spec" : "Looks in spec";
    var thumb = "";
    if (result.previewKind === "image" && result.previewUrl) {
      thumb = '<button type="button" class="ezink-art__thumb" data-ezink-open-preview>' +
        '<img src="' + result.previewUrl.replace(/"/g, "&quot;") + '" alt="Preview of ' + escapeHtml(result.name) + '"></button>';
    } else if (result.previewKind === "embed" && result.previewUrl) {
      thumb = '<a class="ezink-art__thumb ezink-art__thumb--file" href="' + escapeHtml(result.previewUrl) + '" target="_blank" rel="noopener">Open PDF</a>';
    } else {
      thumb = '<div class="ezink-art__thumb ezink-art__thumb--file">.' + escapeHtml(result.ext || "file") + "</div>";
    }
    var list = (result.issues || [])
      .map(function (i) {
        return '<li class="ezink-art__issue ezink-art__issue--' + i.level + '">' + escapeHtml(i.message) + "</li>";
      })
      .join("");
    var dims = "";
    if (result.widthPx) dims = result.widthPx + "×" + result.heightPx + " px";
    if (result.pages) dims = (dims ? dims + " · " : "") + result.pages + " page" + (result.pages === 1 ? "" : "s");
    return (
      '<div class="ezink-art__card" data-ezink-card data-preview="' + (result.previewUrl || "") + '">' +
      thumb +
      '<div class="ezink-art__card-body">' +
      '<p class="ezink-art__card-label">' + escapeHtml(result.label) + "</p>" +
      '<p class="ezink-art__card-name">' + escapeHtml(result.name) + (dims ? " · " + dims : "") + "</p>" +
      '<span class="ezink-art__badge ezink-art__badge--' + badge + '">' + badgeText + "</span>" +
      (list ? '<ul class="ezink-art__issues">' + list + "</ul>" : "") +
      "</div></div>"
    );
  }

  function escapeHtml(s) {
    return String(s || "")
      .replace(/&/g, "&amp;")
      .replace(/</g, "&lt;")
      .replace(/>/g, "&gt;")
      .replace(/"/g, "&quot;");
  }

  var ART_LOCS = [
    "Front",
    "Back",
    "Left chest",
    "Right chest",
    "Left sleeve",
    "Right sleeve",
    "Nape",
    "Other"
  ];
  var ART_LOC_SIZE = {
    Front: [8.3, 11.7],
    Back: [11.7, 16.5],
    "Left chest": [4, 4],
    "Right chest": [4, 4],
    "Left sleeve": [2.5, 2.5],
    "Right sleeve": [2.5, 2.5],
    Nape: [2.5, 2.5]
  };
  var ART_SIZE_FALLBACK = [
    { v: "XS", w: 1.5, h: 1.5, label: "XS — 1.5 × 1.5 in" },
    { v: "SM", w: 2.5, h: 2.5, label: "SM — 2.5 × 2.5 in" },
    { v: "LC", w: 4, h: 4, label: "LC — 4 × 4 in" },
    { v: "A5", w: 5.8, h: 8.3, label: "A5 — 5.8 × 8.3 in" },
    { v: "A5L", w: 11.7, h: 4.25, label: "A5 Long — 11.7 × 4.25 in" },
    { v: "A4", w: 8.3, h: 11.7, label: "A4 — 8.3 × 11.7 in" },
    { v: "A4L", w: 16.5, h: 5.85, label: "A4 Long — 16.5 × 5.85 in" },
    { v: "SQ", w: 11.7, h: 11.7, label: "SQ — 11.7 × 11.7 in" },
    { v: "A3", w: 11.7, h: 16.5, label: "A3 — 11.7 × 16.5 in" },
    { v: "custom", w: 0, h: 0, label: "Custom" }
  ];
  var SIZE_OPTION_NAMES = { A5L: "A5 Long", A4L: "A4 Long" };
  function inchLabel(n) {
    return Math.round(n) === n ? String(Math.round(n)) : String(n);
  }
  function artSizePresets() {
    var sizes = window.EZINKHtv && EZINKHtv.sizes;
    if (!sizes || !sizes.length) return ART_SIZE_FALLBACK;
    var out = sizes.map(function (s) {
      var name = SIZE_OPTION_NAMES[s.id] || s.id;
      return { v: s.id, w: s.w, h: s.h, label: name + " — " + inchLabel(s.w) + " × " + inchLabel(s.h) + " in" };
    });
    out.push({ v: "custom", w: 0, h: 0, label: "Custom" });
    return out;
  }
  var ART_TRANSFER_FALLBACK = [
    { id: "WE1", label: "Wearable 1 Color", hint: "One solid color. Default at 10+ pieces." },
    { id: "WE", label: "Wearable", hint: "Cotton, poly-cotton, and non-sublimated polyester. Full color." },
    { id: "DF", label: "DTF", hint: "1-piece minimum. Used under 10 pieces." },
    { id: "LM1", label: "LoMelt 1 Color", hint: "One solid color. Same LoMelt process, quoted as a single-color job." },
    { id: "LM", label: "LoMelt", hint: "Heat-sensitive and performance fabrics." },
    { id: "BL1", label: "Blocker 1 Color", hint: "One solid color. Same Blocker process, quoted as a single-color job." },
    { id: "BL", label: "Blocker", hint: "Sublimated or dye-migrating polyester." },
    { id: "SB1", label: "Soft Shell Blocker 1 Color", hint: "One solid color. Same Soft Shell Blocker process, quoted as a single-color job." },
    { id: "SB", label: "Soft Shell Blocker", hint: "Softshell jackets and similar fabrics." },
    { id: "LB1", label: "LoMelt Blocker 1 Color", hint: "One solid color. Same LoMelt Blocker process, quoted as a single-color job." },
    { id: "LB", label: "LoMelt Blocker", hint: "Heat-sensitive fabrics that may bleed." },
    { id: "HW1", label: "Headwear 1 Color", hint: "One solid color. Same Headwear process, quoted as a single-color job." },
    { id: "HW", label: "Headwear", hint: "Caps and structured hats." },
    { id: "SR", label: "Reflective", hint: "High-visibility and night safety prints." },
    { id: "PR1", label: "Promo 1 Color", hint: "One solid color. Same Promo process, quoted as a single-color job." },
    { id: "PR", label: "Promo", hint: "Bags, umbrellas, and coated promo items." },
    { id: "NE", label: "Neon", hint: "Fluorescent colors. 20-piece minimum." },
    { id: "NB", label: "Neon Blocker", hint: "Neon on fabrics that may bleed. 20-piece minimum." }
  ];
  function transferTypes() {
    return (window.EZINKHtv && EZINKHtv.types && EZINKHtv.types.length)
      ? EZINKHtv.types
      : ART_TRANSFER_FALLBACK;
  }
  function transferMeta(id) {
    var list = transferTypes();
    var fallback = list[0];
    for (var i = 0; i < list.length; i++) {
      if (list[i].id === id) return list[i];
      if (list[i].id === "WE1") fallback = list[i];
    }
    return fallback;
  }

  function artPdp(wrap) {
    if (!wrap) return null;
    if (wrap.getAttribute && wrap.getAttribute("data-ezink-art-pdp") != null) return wrap;
    return (wrap.closest && wrap.closest("[data-ezink-art-pdp]")) || wrap;
  }

  function pdpQty(pdp) {
    var root = (pdp && pdp.closest && (
      pdp.closest("form.product-form") ||
      pdp.closest("[data-section-type='product']") ||
      pdp.closest("[id^='ProductSection-']")
    )) || document;
    var grid = (root.querySelector && root.querySelector("[data-ezink-size-qty-grid]")) ||
      document.querySelector("[data-ezink-size-qty-grid]");
    var qty = 0;
    if (grid) {
      grid.querySelectorAll("[data-ezink-size-qty-input]").forEach(function (inp) {
        if (inp.disabled) return;
        qty += parseInt(inp.value, 10) || 0;
      });
      return qty;
    }
    var q = (root.querySelector && root.querySelector("[data-ezink-qty-input], input[name='quantity']")) ||
      document.querySelector("[data-ezink-qty-input]");
    return q ? (parseInt(q.value, 10) || 0) : 0;
  }

  function availableTransferList(pdp, qty) {
    if (window.EZINKHtv && typeof window.EZINKHtv.availableTypes === "function") {
      return window.EZINKHtv.availableTypes(pdp, qty);
    }
    if ((parseInt(qty, 10) || 0) < 10) {
      return transferTypes().filter(function (t) { return t.id === "DF"; });
    }
    return transferTypes();
  }

  function preferredTransferId(avail, current, forced, pdp) {
    if (window.EZINKHtv && typeof window.EZINKHtv.preferredTypeId === "function") {
      return window.EZINKHtv.preferredTypeId(avail, current, { forced: !!forced, src: pdp });
    }
    if (avail.length === 1) return avail[0].id;
    return current || (avail[0] && avail[0].id) || "WE1";
  }

  function transferSelectValues(sel) {
    return Array.prototype.map.call(sel.options || [], function (o) { return o.value; }).join("|");
  }

  function fillTransferSelect(sel, pdp, qty) {
    if (!sel || sel.getAttribute("data-ezink-product-method") === "1") return false;
    var avail = availableTransferList(pdp, qty);
    if (!avail.length) avail = transferTypes();
    var wasAuto = sel.getAttribute("data-ezink-type-auto") !== "0";
    var pick = preferredTransferId(avail, sel.value, wasAuto, pdp);
    var ids = avail.map(function (t) { return t.id; }).join("|");
    var changed = transferSelectValues(sel) !== ids || sel.value !== pick;
    if (transferSelectValues(sel) !== ids) {
      sel.innerHTML = avail.map(function (t) {
        return '<option value="' + t.id + '">' + t.label + "</option>";
      }).join("");
    }
    if (pick) sel.value = pick;
    if (avail.length === 1) sel.setAttribute("data-ezink-type-auto", "1");
    var hint = sel.parentNode && sel.parentNode.querySelector("[data-ezink-art-transfer-hint]");
    var meta = transferMeta(sel.value);
    var note = (window.EZINKHtv && typeof window.EZINKHtv.availabilityNote === "function")
      ? window.EZINKHtv.availabilityNote(pdp, qty)
      : "";
    if (hint) hint.textContent = note || meta.hint || "";
    return changed;
  }

  function refreshTransferSelects(wrap) {
    if (!wrap) return;
    var pdp = artPdp(wrap);
    var qty = pdpQty(pdp);
    var changed = false;
    wrap.querySelectorAll("[data-ezink-art-transfer]").forEach(function (sel) {
      var item = sel.closest("[data-ezink-art-item]");
      if (fillTransferSelect(sel, pdp, qty)) {
        changed = true;
        if (item) syncItemNames(wrap, item);
      }
    });
    if (changed) emitArtChange(pdp || wrap);
  }

  function refreshAllPrintTypes() {
    document.querySelectorAll("[data-ezink-art-items]").forEach(refreshTransferSelects);
  }
  window.ezinkRefreshPrintTypes = refreshAllPrintTypes;

  function apparelArtCount() {
    return document.querySelectorAll(
      "[data-ezink-art-pdp][data-ezink-art-mode='apparel'] [data-ezink-art-item]"
    ).length;
  }

  function applyQuoteState(qty) {
    if (!document.querySelector("[data-ezink-size-qty-grid]")) return;
    if (qty == null) qty = pdpQty(document.querySelector("[data-ezink-art-pdp]") || document.body);
    var hasArt = apparelArtCount() > 0;
    var showQuote = qty > 0 && hasArt;
    var note = "";
    if (!hasArt) note = "Add an artwork location to see the price.";
    else if (qty < 1) note = "Enter sizes & qty to see the price.";
    document.querySelectorAll("[data-ezink-price-wrap], [data-ezink-atc-sticky]").forEach(function (el) {
      el.classList.toggle("is-quote-pending", !showQuote);
    });
    document.querySelectorAll("[data-ezink-price-total], [data-ezink-price-unit]").forEach(function (el) {
      el.hidden = !showQuote;
    });
    document.querySelectorAll("[data-ezink-price-note]").forEach(function (el) {
      if (showQuote) {
        if (!el.textContent) el.hidden = true;
        return;
      }
      el.hidden = !note;
      el.textContent = note;
    });
    document.querySelectorAll("[data-ezink-price-tiers]").forEach(function (el) {
      el.classList.toggle("is-pending", !showQuote);
      var pending = el.querySelector("[data-ezink-tiers-pending]");
      if (!pending) return;
      if (!hasArt) pending.textContent = "Add an artwork location to see estimated prices.";
      else if (qty < 1) pending.textContent = "Enter sizes & qty to see estimated prices.";
    });
    document.querySelectorAll("[data-ezink-art-add]").forEach(function (btn) {
      if (btn.hidden) return;
      btn.classList.toggle("is-attention", !hasArt);
    });
  }
  window.ezinkApplyQuoteState = applyQuoteState;

  function namedItems(wrap) {
    return wrap && wrap.getAttribute("data-named") === "1";
  }

  function artRoot(el) {
    return (el && el.closest("[data-ezink-art-pdp], [data-ezink-line]")) || el;
  }

  function isPrintArt(el) {
    var root = artRoot(el);
    return !!(root && root.getAttribute("data-ezink-art-mode") === "print");
  }

  function printFormRoot(el) {
    var root = artRoot(el);
    return (root && root.closest && root.closest("form")) || document;
  }

  function printOptValue(el, key) {
    var form = printFormRoot(el);
    var sel = form.querySelector('[data-ezink-print-opt="' + key + '"]');
    return sel && sel.value ? String(sel.value) : "";
  }

  function printColorspec(el) {
    var raw = printOptValue(el, "colorspec").toLowerCase();
    if (!raw) return "both";
    if (raw.indexOf("back") !== -1 && raw.indexOf("4/0") === -1) return "both";
    if (
      raw === "front" ||
      raw.indexOf("4/0") !== -1 ||
      raw.indexOf("front only") !== -1 ||
      (raw.indexOf("front") !== -1 && raw.indexOf("back") === -1)
    ) {
      return "front";
    }
    return "both";
  }

  function printSpotUv(el) {
    var raw = printOptValue(el, "spotuv").toLowerCase();
    if (!raw || raw.indexOf("no spot") !== -1 || raw === "none") return "none";
    // Full-cover UV on the front does not need a mask file — only Spot UV Back.
    if (
      raw.indexOf("back") !== -1 &&
      (raw.indexOf("full uv") !== -1 || raw.indexOf("full-uv") !== -1)
    ) {
      return "back";
    }
    if (raw.indexOf("both") !== -1) return "both";
    var front = raw.indexOf("front") !== -1;
    var back = raw.indexOf("back") !== -1;
    if (front && back) return "both";
    if (back) return "back";
    if (front) return "front";
    return "none";
  }

  function printArtSlots(el) {
    var slots = printColorspec(el) === "front" ? ["Front"] : ["Front", "Back"];
    var uv = printSpotUv(el);
    if (uv === "front" || uv === "both") slots.push("Spot UV Front");
    if (uv === "back" || uv === "both") slots.push("Spot UV Back");
    return slots;
  }

  function printSides(el) {
    return printColorspec(el) === "front" ? 1 : 2;
  }

  function printDropTitle(loc) {
    if (loc === "Back") return "Drop back artwork";
    if (loc === "Spot UV Front") return "Drop Spot UV front artwork";
    if (loc === "Spot UV Back") return "Drop Spot UV back artwork";
    return "Drop front artwork";
  }

  function syncPrintArtSlots(wrap) {
    if (!wrap || !isPrintArt(wrap)) return;
    var root = artRoot(wrap);
    var slots = printArtSlots(wrap);
    if (root && root.setAttribute) root.setAttribute("data-ezink-sides", String(printSides(wrap)));
    var list = wrap.querySelector("[data-ezink-art-list]");
    if (!list) return;
    var byLabel = {};
    wrap.querySelectorAll("[data-ezink-art-item]").forEach(function (item) {
      var lab = item.getAttribute("data-art-label") || locationBase(item);
      byLabel[lab] = item;
    });
    slots.forEach(function (loc) {
      if (!byLabel[loc]) addArtItem(wrap, loc);
    });
    wrap.querySelectorAll("[data-ezink-art-item]").forEach(function (item) {
      var lab = item.getAttribute("data-art-label") || locationBase(item);
      if (slots.indexOf(lab) === -1) item.remove();
    });
    slots.forEach(function (loc) {
      wrap.querySelectorAll("[data-ezink-art-item]").forEach(function (item) {
        if ((item.getAttribute("data-art-label") || locationBase(item)) === loc) {
          list.appendChild(item);
        }
      });
    });
    wrap.querySelectorAll("[data-ezink-art-item]").forEach(function (el) {
      syncItemNames(wrap, el);
    });
    var btn = wrap.querySelector("[data-ezink-art-add]");
    if (btn) btn.hidden = true;
  }

  function syncPrintAdd(wrap) {
    syncPrintArtSlots(wrap);
  }

  function locationBase(item) {
    var sel = item.querySelector("[data-ezink-art-loc]");
    var val = sel ? sel.value : "Front";
    if (val === "Other") {
      var other = item.querySelector("[data-ezink-art-loc-other]");
      var custom = other && other.value.trim();
      return custom || "Other";
    }
    return val || "Front";
  }

  function sizeInches(item) {
    var w = parseFloat((item.querySelector("[data-ezink-art-w]") || {}).value);
    var h = parseFloat((item.querySelector("[data-ezink-art-h]") || {}).value);
    if (!(w > 0) || !(h > 0)) return null;
    var preset = item.querySelector("[data-ezink-art-size-preset]");
    var opt = preset && preset.options && preset.selectedIndex >= 0 ? preset.options[preset.selectedIndex] : null;
    var custom = opt && opt.getAttribute("data-label");
    if (custom && opt.getAttribute("data-w")) {
      var listedW = parseFloat(opt.getAttribute("data-w"));
      var listedH = parseFloat(opt.getAttribute("data-h"));
      if (Math.abs(listedW - w) > 0.001 || Math.abs(listedH - h) > 0.001) custom = "";
    }
    return { w: w, h: h, label: custom || (w + "×" + h + " in"), sq: Math.round(w * h * 100) / 100 };
  }

  function readArtSpecs(wrap) {
    var node = artRoot(wrap);
    var raw = node && node.getAttribute && node.getAttribute("data-ezink-art-specs");
    if (!raw) return null;
    try {
      var parsed = JSON.parse(raw);
      if (!parsed || !parsed.locations || !parsed.locations.length) return null;
      return parsed;
    } catch (err) {
      return null;
    }
  }

  function specLocation(specs, name) {
    var locs = (specs && specs.locations) || [];
    for (var i = 0; i < locs.length; i++) {
      if (locs[i].name === name) return locs[i];
    }
    return locs[0] || null;
  }

  function specSizes(loc) {
    if (!loc) return [];
    if (loc.sizes && loc.sizes.length) return loc.sizes;
    if (loc.w > 0 && loc.h > 0) return [loc];
    return [];
  }

  function escAttr(value) {
    return String(value || "").replace(/&/g, "&amp;").replace(/"/g, "&quot;");
  }

  function uniqueLocation(list, item, base) {
    var used = {};
    list.querySelectorAll("[data-ezink-art-item]").forEach(function (el) {
      if (el === item) return;
      var lab = el.getAttribute("data-art-label");
      if (lab) used[lab] = true;
    });
    if (!used[base]) return base;
    var n = 2;
    while (used[base + " " + n]) n += 1;
    return base + " " + n;
  }

  function emitArtChange(root) {
    try {
      document.dispatchEvent(new CustomEvent("ezink-art-items-change", { detail: { root: root } }));
    } catch (err) {}
    try {
      if (typeof window.ezinkUpdatePdpPrice === "function") window.ezinkUpdatePdpPrice();
    } catch (err2) {}
    try {
      applyQuoteState();
    } catch (err3) {}
  }

  function syncDecoration(wrap) {
    if (!wrap) return;
    var rows = [];
    wrap.querySelectorAll("[data-ezink-art-item]").forEach(function (item) {
      var loc = item.getAttribute("data-art-label") || locationBase(item);
      var size = sizeInches(item);
      var inp = item.querySelector("[data-ezink-file]");
      var hasFile = inp && inp.files && inp.files[0];
      var tSel = item.querySelector("[data-ezink-art-transfer]");
      var tMeta = transferMeta(tSel ? tSel.value : "WE1");
      rows.push({
        location: loc,
        width_in: size ? size.w : null,
        height_in: size ? size.h : null,
        sq_in: size ? size.sq : null,
        has_file: !!hasFile,
        transfer: tMeta.id,
        transfer_label: tMeta.label
      });
    });
    var deco = wrap.querySelector("[data-ezink-decoration]");
    var map = wrap.querySelector("[data-ezink-art-map]");
    var summary = wrap.querySelector("[data-ezink-deco-summary]");
    var printMode = isPrintArt(wrap);
    var text = rows
      .map(function (r) {
        var typeBit = r.transfer_label ? " · " + r.transfer_label : "";
        if (r.width_in) return r.location + " " + r.width_in + "×" + r.height_in + " in" + typeBit;
        return printMode ? r.location : r.location + " (size needed)" + typeBit;
      })
      .join("; ");
    if (deco) deco.value = text.slice(0, 500);
    if (map) map.value = JSON.stringify(rows).slice(0, 1500);
    if (summary) {
      summary.hidden = true;
      summary.textContent = "";
    }
  }

  function syncItemNames(wrap, item) {
    var list = wrap.querySelector("[data-ezink-art-list]");
    var loc = uniqueLocation(list, item, locationBase(item));
    item.setAttribute("data-art-label", loc);
    var fileInp = item.querySelector("[data-ezink-file]");
    var sizeField = item.querySelector("[data-ezink-art-size]");
    var title = item.querySelector("[data-ezink-art-title]");
    if (title) title.textContent = loc;
    var nameEl = item.querySelector("[data-ezink-art-filename]");
    if (nameEl) {
      var chosen = fileInp && fileInp.files && fileInp.files[0] ? fileInp.files[0].name : "";
      nameEl.textContent = chosen;
      nameEl.hidden = !chosen;
    }
    if (fileInp) fileInp.setAttribute("data-ezink-file", "Artwork — " + loc);
    var size = sizeInches(item);
    if (sizeField) sizeField.value = size ? size.label : "";
    var tSel = item.querySelector("[data-ezink-art-transfer]");
    var tField = item.querySelector("[data-ezink-art-transfer-field]");
    var tHint = item.querySelector("[data-ezink-art-transfer-hint]");
    var productMethod = item.getAttribute("data-art-method") || "";
    if (productMethod || (tSel && tSel.getAttribute("data-ezink-product-method") === "1")) {
      var methodName = productMethod || (tSel && tSel.value) || "";
      if (tField) tField.value = methodName;
      if (tHint) tHint.textContent = item.getAttribute("data-art-hint") || "";
    } else {
      var tMeta = transferMeta(tSel ? tSel.value : "WE1");
      if (tField) tField.value = tMeta.label;
      if (tHint) tHint.textContent = tMeta.hint || "";
    }
    var linkInp = item.querySelector("[data-ezink-art-link]");
    var notesInp = item.querySelector("[data-ezink-art-notes]");
    if (namedItems(wrap)) {
      var slug = String(loc || "front").toLowerCase().replace(/[^a-z0-9]+/g, "_").replace(/^_|_$/g, "") || "front";
      if (fileInp) fileInp.name = "properties[_shopfile_" + slug + "]";
      if (sizeField) sizeField.name = "properties[Size — " + loc + "]";
      if (tField) tField.name = "properties[Print type — " + loc + "]";
      if (linkInp) linkInp.name = "properties[Artwork link — " + loc + "]";
      if (notesInp) notesInp.name = "properties[Artwork notes — " + loc + "]";
    }
    var otherWrap = item.querySelector("[data-ezink-art-other]");
    var sel = item.querySelector("[data-ezink-art-loc]");
    if (otherWrap) otherWrap.hidden = !(sel && sel.value === "Other");
    syncDecoration(wrap);
  }

  function paintProductMethod(item, method, hint) {
    item.setAttribute("data-art-method", method || "");
    item.setAttribute("data-art-hint", hint || "");
    var tSel = item.querySelector("[data-ezink-art-transfer]");
    if (!tSel || !method) return;
    tSel.setAttribute("data-ezink-product-method", "1");
    tSel.innerHTML = '<option value="' + escAttr(method) + '" selected>' + escAttr(method) + "</option>";
  }

  function sizeOptionsFor(loc) {
    var sizes = specSizes(loc);
    if (!sizes.length) return '<option value="custom">Custom</option>';
    return sizes.map(function (row, i) {
      var label = row.label || (row.w + "×" + row.h + " in");
      var text = row.method && sizes.length > 1 ? row.method + " — " + label : label;
      return '<option value="s' + i + '" data-w="' + row.w + '" data-h="' + row.h + '" data-method="' + escAttr(row.method || "") + '" data-hint="' + escAttr(row.hint || "") + '" data-label="' + escAttr(label) + '"' + (i === 0 ? " selected" : "") + ">" + text + "</option>";
    }).join("");
  }

  function applyLocDefaultSize(item, loc, force) {
    var wrap = item.closest && item.closest("[data-ezink-art-items]");
    var specs = wrap && readArtSpecs(wrap);
    if (specs) {
      var row = specLocation(specs, loc);
      var sel = item.querySelector("[data-ezink-art-size-preset]");
      var wEl = item.querySelector("[data-ezink-art-w]");
      var hEl = item.querySelector("[data-ezink-art-h]");
      if (sel) sel.innerHTML = sizeOptionsFor(row);
      var size = specSizes(row)[0];
      if (size && wEl && hEl && (force || !wEl.value || !hEl.value)) {
        wEl.value = size.w;
        hEl.value = size.h;
        wEl.max = String(size.w);
        hEl.max = String(size.h);
        if (sel) sel.value = "s0";
      }
      paintProductMethod(item, (size && size.method) || (row && row.method) || "", (size && size.hint) || (row && row.hint) || "");
      var tLock = item.querySelector("[data-ezink-art-transfer]");
      if (tLock) tLock.setAttribute("data-ezink-product-method", "1");
      return;
    }
    var preset = ART_LOC_SIZE[loc];
    var wEl = item.querySelector("[data-ezink-art-w]");
    var hEl = item.querySelector("[data-ezink-art-h]");
    var sel = item.querySelector("[data-ezink-art-size-preset]");
    if (!wEl || !hEl) return;
    if (!force && wEl.value && hEl.value) return;
    if (!preset) {
      if (sel) sel.value = "custom";
      return;
    }
    wEl.value = preset[0];
    hEl.value = preset[1];
    if (sel) {
      var hit = artSizePresets().filter(function (p) {
        return Math.abs(p.w - preset[0]) < 0.001 && Math.abs(p.h - preset[1]) < 0.001;
      })[0];
      sel.value = hit ? hit.v : "custom";
    }
  }

  function addArtItem(wrap, loc) {
    var specs = isPrintArt(wrap) ? null : readArtSpecs(wrap);
    var specNames = specs ? specs.locations.map(function (row) { return row.name; }).filter(Boolean) : null;
    loc = loc || (specNames && specNames[0]) || "Front";
    var list = wrap.querySelector("[data-ezink-art-list]");
    if (!list) return null;
    var uid = wrap.getAttribute("data-uid") || "pdp";
    var id = "art" + Math.random().toString(36).slice(2, 8);
    var locSource = specNames && specNames.length ? specNames : ART_LOCS;
    var locOpts = locSource.map(function (name) {
      return '<option value="' + escAttr(name) + '"' + (name === loc ? " selected" : "") + ">" + name + "</option>";
    }).join("");
    var sizeOpts = specs
      ? sizeOptionsFor(specLocation(specs, loc))
      : '<option value="">Choose size</option>' + artSizePresets().map(function (p) {
        return '<option value="' + p.v + '">' + p.label + "</option>";
      }).join("");
    var typeOpts = "";
    var printMode = isPrintArt(wrap);
    var dropTitle = printMode ? printDropTitle(loc) : "Drop artwork or click to upload";
    var removeBtn = printMode
      ? ""
      : '<button type="button" class="ezink-art-item__remove" data-ezink-art-remove aria-label="Remove artwork location">&times;</button>';
    var fields = printMode
      ? '<input type="hidden" data-ezink-art-loc value="' + String(loc).replace(/"/g, "&quot;") + '">'
      : '<div class="ezink-art-item__fields">' +
        '<label class="ezink-art-item__field">Location' +
        '<select class="product-form__input" data-ezink-art-loc>' + locOpts + '</select></label>' +
        '<label class="ezink-art-item__field ezink-art-item__other" data-ezink-art-other hidden>Name' +
        '<input class="product-form__input" type="text" maxlength="40" data-ezink-art-loc-other placeholder="e.g. wrap, pocket"></label>' +
        '<label class="ezink-art-item__field">Print size' +
        '<select class="product-form__input" data-ezink-art-size-preset>' + sizeOpts + '</select></label>' +
        '<label class="ezink-art-item__field ezink-art-item__wh">W × H (in)' +
        '<span class="ezink-art-item__wh-row">' +
        '<input class="product-form__input" type="number" min="' + (specs ? "0.1" : "0.5") + '" max="24" step="' + (specs ? "0.001" : "0.25") + '" data-ezink-art-w placeholder="W" inputmode="decimal">' +
        "<span>×</span>" +
        '<input class="product-form__input" type="number" min="' + (specs ? "0.1" : "0.5") + '" max="24" step="' + (specs ? "0.001" : "0.25") + '" data-ezink-art-h placeholder="H" inputmode="decimal">' +
        "</span></label>" +
        '<label class="ezink-art-item__field ezink-art-item__field--wide">Print type' +
        '<select class="product-form__input" data-ezink-art-transfer data-ezink-type-auto="1">' + typeOpts + "</select>" +
        '<span class="ezink-art-item__hint" data-ezink-art-transfer-hint></span></label>' +
        "</div>";
    var extras =
      '<div class="ezink-art-item__extras">' +
      '<label class="ezink-art-item__field ezink-art-item__field--wide">Cloud link' +
      '<input class="product-form__input" type="text" maxlength="500" autocomplete="off" data-ezink-art-link placeholder="Drive, Dropbox, or WeTransfer"></label>' +
      '<label class="ezink-art-item__field ezink-art-item__field--wide">Notes' +
      '<textarea class="product-form__input ezink-art-item__notes" rows="2" maxlength="500" data-ezink-art-notes placeholder="Finish, placement, which file…"></textarea></label>' +
      "</div>";
    var item = document.createElement("div");
    item.className = "ezink-art-item";
    item.setAttribute("data-ezink-art-item", "");
    item.setAttribute("data-art-id", id);
    item.innerHTML =
      '<div class="ezink-art-item__bar">' +
      '<p class="ezink-art-item__title" data-ezink-art-title>' + loc + "</p>" +
      removeBtn +
      "</div>" +
      '<p class="ezink-art-item__file" data-ezink-art-filename hidden></p>' +
      fields +
      '<input type="hidden" value="" data-ezink-art-size>' +
      (printMode ? "" : '<input type="hidden" value="" data-ezink-art-transfer-field>') +
      '<label class="ezink-art__drop" data-ezink-side="file" for="ezink-art-file-' + uid + "-" + id + '">' +
      '<input id="ezink-art-file-' + uid + "-" + id + '" class="ezink-art__file-input" type="file" ' +
      'accept=".pdf,.ai,.eps,.psd,.tif,.tiff,.png,.jpg,.jpeg,.svg,.zip,.webp" data-ezink-file>' +
      '<div class="ezink-art__drop-idle">' +
      '<span class="ezink-art__drop-kicker">File</span>' +
      '<span class="ezink-art__drop-title">' + dropTitle + "</span>" +
      '<span class="ezink-art__drop-hint">PDF, AI, EPS, PNG, JPG · max 20&nbsp;MB</span>' +
      "</div>" +
      '<div class="ezink-art__drop-preview" data-ezink-drop-preview hidden></div>' +
      "</label>" +
      extras;
    list.appendChild(item);
    if (!printMode) applyLocDefaultSize(item, loc, true);
    fillTransferSelect(item.querySelector("[data-ezink-art-transfer]"), artPdp(wrap), pdpQty(artPdp(wrap)));
    syncItemNames(wrap, item);
    emitArtChange(wrap.closest("[data-ezink-art-pdp], [data-ezink-line]") || wrap);
    return item;
  }

  function initArtItems(root) {
    var wrap = root.querySelector("[data-ezink-art-items]");
    if (!wrap || wrap.getAttribute("data-inited") === "1") return wrap;
    wrap.setAttribute("data-inited", "1");
    wrap.addEventListener("click", function (evt) {
      if (evt.target.closest("[data-ezink-art-add]")) {
        evt.preventDefault();
        if (isPrintArt(wrap)) {
          syncPrintArtSlots(wrap);
          return;
        }
        var used = {};
        wrap.querySelectorAll("[data-ezink-art-loc]").forEach(function (sel) {
          used[sel.value] = true;
        });
        var specs = readArtSpecs(wrap);
        var names = specs ? specs.locations.map(function (row) { return row.name; }).filter(Boolean) : ART_LOCS;
        var next = "";
        for (var i = 0; i < names.length; i++) {
          if (names[i] !== "Other" && !used[names[i]]) {
            next = names[i];
            break;
          }
        }
        if (!next) return;
        addArtItem(wrap, next);
        return;
      }
      var rm = evt.target.closest("[data-ezink-art-remove]");
      if (rm) {
        evt.preventDefault();
        var item = rm.closest("[data-ezink-art-item]");
        if (item) item.remove();
        wrap.querySelectorAll("[data-ezink-art-item]").forEach(function (el) {
          syncItemNames(wrap, el);
        });
        syncPrintAdd(wrap);
        emitArtChange(root);
      }
    });
    wrap.addEventListener("change", function (evt) {
      var item = evt.target.closest("[data-ezink-art-item]");
      if (!item) return;
      if (evt.target.matches("[data-ezink-art-transfer]")) {
        evt.target.setAttribute("data-ezink-type-auto", "0");
      }
      if (evt.target.matches("[data-ezink-art-link]")) syncCloudPreview(item);
      if (evt.target.matches("[data-ezink-art-loc]")) {
        applyLocDefaultSize(item, evt.target.value, true);
      }
      if (evt.target.matches("[data-ezink-art-size-preset]")) {
        var chosen = evt.target.options && evt.target.selectedIndex >= 0 ? evt.target.options[evt.target.selectedIndex] : null;
        if (chosen && chosen.getAttribute("data-w")) {
          item.querySelector("[data-ezink-art-w]").value = chosen.getAttribute("data-w");
          item.querySelector("[data-ezink-art-h]").value = chosen.getAttribute("data-h");
          var wMax = item.querySelector("[data-ezink-art-w]");
          var hMax = item.querySelector("[data-ezink-art-h]");
          if (wMax) wMax.max = chosen.getAttribute("data-w");
          if (hMax) hMax.max = chosen.getAttribute("data-h");
          paintProductMethod(item, chosen.getAttribute("data-method") || "", chosen.getAttribute("data-hint") || "");
        } else {
          var hit = artSizePresets().filter(function (p) { return p.v === evt.target.value; })[0];
          if (hit && hit.w) {
            item.querySelector("[data-ezink-art-w]").value = hit.w;
            item.querySelector("[data-ezink-art-h]").value = hit.h;
          }
        }
      }
      syncItemNames(wrap, item);
      emitArtChange(root);
    });
    wrap.addEventListener("input", function (evt) {
      var item = evt.target.closest("[data-ezink-art-item]");
      if (!item) return;
      if (evt.target.matches("[data-ezink-art-link]")) syncCloudPreview(item);
      if (evt.target.matches("[data-ezink-art-w], [data-ezink-art-h]")) {
        var sel = item.querySelector("[data-ezink-art-size-preset]");
        if (sel) sel.value = "custom";
      }
      syncItemNames(wrap, item);
      emitArtChange(root);
    });
    if (isPrintArt(wrap)) {
      syncPrintArtSlots(wrap);
    }
    return wrap;
  }

  window.EZINKArtItems = {
    list: function (root) {
      if (!root) return [];
      var wrap = root.matches && root.matches("[data-ezink-art-items]")
        ? root
        : root.querySelector("[data-ezink-art-items]");
      if (!wrap && root.closest) {
        var pdp = root.closest("[data-ezink-art-pdp]") || document.querySelector("[data-ezink-art-pdp]");
        wrap = pdp && pdp.querySelector("[data-ezink-art-items]");
      }
      if (!wrap) return [];
      var out = [];
      wrap.querySelectorAll("[data-ezink-art-item]").forEach(function (item) {
        var inp = item.querySelector("[data-ezink-file]");
        var size = sizeInches(item);
        out.push({
          id: item.getAttribute("data-art-id"),
          label: item.getAttribute("data-art-label") || locationBase(item),
          el: item,
          input: inp,
          file: inp && inp.files && inp.files[0] ? inp.files[0] : null,
          size: size,
          transfer: transferMeta(item.querySelector("[data-ezink-art-transfer]")
            ? item.querySelector("[data-ezink-art-transfer]").value
            : "WE1"),
          widthIn: size ? size.w : null,
          heightIn: size ? size.h : null
        });
      });
      return out;
    }
  };

  function setSummaryField(root, results) {
    var field = root.querySelector("[data-ezink-check-summary]");
    if (!field) return;
    var bits = results.map(function (r) {
      return r.label + ": " + r.summary;
    });
    field.value = bits.join(" | ").slice(0, 900);
  }

  function sideFromLabel(label) {
    return /back/i.test(label || "") ? "back" : "front";
  }

  function resetDrop(drop) {
    if (!drop) return;
    drop.classList.remove("has-file");
    var idle = drop.querySelector(".ezink-art__drop-idle");
    var box = drop.querySelector("[data-ezink-drop-preview]");
    if (idle) idle.hidden = false;
    if (box) {
      box.hidden = true;
      box.innerHTML = "";
    }
  }

  function paintDrop(root, result) {
    var item = result.itemEl || (root && root.querySelector('[data-ezink-art-item]'));
    var drop = item && item.querySelector(".ezink-art__drop");
    if (!drop) drop = root && root.querySelector(".ezink-art__drop");
    if (!drop) return;
    drop.classList.add("has-file");
    var idle = drop.querySelector(".ezink-art__drop-idle");
    var box = drop.querySelector("[data-ezink-drop-preview]");
    if (idle) idle.hidden = true;
    if (box) {
      box.hidden = false;
      box.innerHTML = renderCard(result);
    }
  }

  function applySides(root) {
    if (root) initArtItems(root);
  }

  function runInputPreviews(root) {
    applySides(root);
    var jobs = [];
    root.querySelectorAll('input[type="file"]').forEach(function (inp) {
      if (inp.disabled) return;
      if (inp.hasAttribute("data-ezink-mockup-file")) return;
      var item = inp.closest("[data-ezink-art-item]");
      var drop = inp.closest(".ezink-art__drop");
      if (!inp.files || !inp.files[0]) {
        if (drop && !drop.classList.contains("has-file")) resetDrop(drop);
        return;
      }
      var spec = Check.specFromItem ? Check.specFromItem(root, item) : Check.specFromEl(root);
      var label = inp.getAttribute("data-ezink-file") || "Artwork";
      jobs.push(
        inspectSource({ file: inp.files[0], spec: spec, label: label, name: inp.files[0].name }).then(function (r) {
          r.itemEl = item;
          paintDrop(root, r);
          return r;
        })
      );
    });
    if (!jobs.length) {
      setSummaryField(root, []);
      return Promise.resolve([]);
    }
    return Promise.all(jobs).then(function (results) {
      setSummaryField(root, results);
      root.classList.toggle("ezink-art__line--warn", results.some(function (r) { return !r.ok; }));
      return results;
    });
  }

  function runAttachedPreviews(line) {
    var spec = Check.specFromEl(line);
    applySides(line);
    var jobs = [];
    line.querySelectorAll(".ezink-art__attached a").forEach(function (a) {
      var href = a.getAttribute("href") || "";
      if (!/^https?:/i.test(href) && href.indexOf("//") !== 0) return;
      if (href.indexOf("//") === 0) href = window.location.protocol + href;
      var li = a.closest("li");
      var label = "Artwork";
      if (li && li.querySelector("strong")) {
        label = li.querySelector("strong").textContent.replace(/:\s*$/, "");
      }
      jobs.push(
        inspectSource({ url: href, name: a.textContent.trim() || href, spec: spec, label: label }).then(function (r) {
          paintDrop(line, r);
          return r;
        })
      );
    });
    if (!jobs.length) return Promise.resolve([]);
    return Promise.all(jobs).then(function (results) {
      line.classList.toggle("ezink-art__line--warn", results.some(function (r) { return !r.ok; }));
      return results;
    });
  }

  function collectCheckoutWarnings(form) {
    var msgs = [];
    form.querySelectorAll(".ezink-art__issue--warn, .ezink-art__issue--error").forEach(function (li) {
      if (msgs.indexOf(li.textContent) === -1) msgs.push(li.textContent);
    });
    return msgs;
  }

  document.addEventListener("change", function (evt) {
    var inp = evt.target;
    if (!(inp instanceof HTMLInputElement) || inp.type !== "file") return;
    var root = inp.closest("[data-ezink-art-pdp], [data-ezink-line]");
    if (!root) return;
    if (inp.files && inp.files[0] && fileTooBig(inp.files[0])) {
      inp.value = "";
      window.alert("Each file must be 20 MB or smaller. For larger files, paste a Drive, Dropbox, or WeTransfer link instead.");
      return;
    }
    runInputPreviews(root);
  });

  document.addEventListener("click", function (evt) {
    var locCtl = evt.target && evt.target.closest && evt.target.closest(
      "button[data-ezink-loc-edit], button[data-ezink-loc-delete], button[data-ezink-loc-save], button[data-ezink-loc-cancel]"
    );
    if (locCtl) return;
    var openBtn = evt.target.closest("[data-ezink-open-preview]");
    if (openBtn) {
      evt.preventDefault();
      var src = openBtn.getAttribute("data-preview") || "";
      if (!src) {
        var card = openBtn.closest("[data-ezink-card]");
        src = (card && card.getAttribute("data-preview")) || "";
      }
      if (src) {
        var safe = src.replace(/"/g, "&quot;");
        var isImg = /\.(png|jpe?g|gif|webp|svg)(\?|$)/i.test(src);
        openModal(
          isImg
            ? '<img class="ezink-art-modal__img" src="' + safe + '" alt="Artwork preview">'
            : '<iframe class="ezink-art-modal__img" src="' + safe + '" title="Artwork preview" style="width:min(92vw,960px);height:80vh;border:0;background:#111"></iframe>'
        );
      }
      return;
    }
    var btn = evt.target.closest("[data-ezink-attach]");
    if (!btn) return;
    evt.preventDefault();
    var line = btn.closest("[data-ezink-line]");
    if (!line) return;
    var status = line.querySelector("[data-ezink-status]");
    var inputs = line.querySelectorAll("[data-ezink-file]");
    var picked = [];
    inputs.forEach(function (inp) {
      if (inp.files && inp.files[0]) {
        picked.push({ name: inp.getAttribute("data-ezink-file"), file: inp.files[0] });
      }
    });
    var hasLinkOrNotes = false;
    line.querySelectorAll("[data-ezink-art-item]").forEach(function (item) {
      var linkEl = item.querySelector("[data-ezink-art-link]");
      var notesEl = item.querySelector("[data-ezink-art-notes]");
      if ((linkEl && linkEl.value.trim()) || (notesEl && notesEl.value.trim())) hasLinkOrNotes = true;
    });
    if (!picked.length && !hasLinkOrNotes) {
      showStatus(status, "Choose a file or paste a cloud link for a location.", true);
      return;
    }
    var missingSize = [];
    line.querySelectorAll("[data-ezink-art-item]").forEach(function (item) {
      var inp = item.querySelector("[data-ezink-file]");
      if (inp && inp.files && inp.files[0] && !sizeInches(item)) {
        missingSize.push(item.getAttribute("data-art-label") || "a location");
      }
    });
    if (missingSize.length) {
      showStatus(status, "Enter print size (W × H in) for: " + missingSize.join(", ") + ".", true);
      return;
    }
    for (var i = 0; i < picked.length; i++) {
      if (fileTooBig(picked[i].file)) {
        showStatus(status, "Each file must be 20 MB or smaller. Paste a cloud link on that location instead.", true);
        return;
      }
    }

    var spec = Check.specFromEl(line);
    Promise.all(
      picked.map(function (p) {
        return inspectSource({ file: p.file, spec: spec, label: p.name, name: p.file.name });
      })
    ).then(function (results) {
      results.forEach(function (r) { paintDrop(line, r); });
      var warn = results.some(function (r) { return !r.ok; });
      if (warn) {
        var lines = [];
        results.forEach(function (r) {
          r.issues.filter(function (i) { return i.level === "warn" || i.level === "error"; }).forEach(function (i) {
            lines.push(i.message);
          });
        });
        var go = window.confirm(
          "This artwork may be out of spec:\n\n• " +
            lines.join("\n• ") +
            "\n\nAttach anyway? We proof every job and will contact you if we need a new file."
        );
        if (!go) return;
      }
      attachFiles(line, picked, results, btn, status);
    });
  });

  function cartArtworkPatches(line) {
    var wrap = line.querySelector("[data-ezink-art-items]");
    var patches = [];
    if (!wrap) return patches;
    wrap.querySelectorAll("[data-ezink-art-item]").forEach(function (item) {
      var loc = item.getAttribute("data-art-label") || locationBase(item);
      var inp = item.querySelector("[data-ezink-file]");
      var file = inp && inp.files && inp.files[0] ? inp.files[0] : null;
      var linkEl = item.querySelector("[data-ezink-art-link]");
      var notesEl = item.querySelector("[data-ezink-art-notes]");
      var link = linkEl && linkEl.value.trim() ? linkEl.value.trim() : "";
      if (!file && !link) return;
      var size = sizeInches(item);
      var tSel = item.querySelector("[data-ezink-art-transfer]");
      var typeLabel = "";
      if (tSel && tSel.options && tSel.selectedIndex >= 0 && tSel.options[tSel.selectedIndex]) {
        typeLabel = String(tSel.options[tSel.selectedIndex].text || "").trim();
      }
      patches.push({
        loc: loc,
        file: file,
        linkUrl: link,
        notes: notesEl && notesEl.value.trim() ? notesEl.value.trim() : "",
        sizeLabel: size ? size.label : "",
        typeLabel: typeLabel
      });
    });
    return patches;
  }

  function artworkLocationsInPlace(line) {
    var map = {};
    line.querySelectorAll(".ezink-art__loc-card").forEach(function (card) {
      var loc = card.getAttribute("data-loc") || "";
      if (!loc) return;
      var ext = card.querySelector(".ezink-art__loc-ext");
      var has = card.querySelector(".ezink-art__loc-file, .ezink-art__loc-cloud, .ezink-art__loc-thumb img");
      if (has || (ext && String(ext.textContent || "").trim() === "FILE")) map[loc.toLowerCase()] = loc;
    });
    return map;
  }

  function replacementNotice(names) {
    var list = names.slice();
    var last = list.pop();
    var who = list.length ? list.join(", ") + " and " + last : last;
    var only = names.length === 1 ? who + " is" : "those locations are";
    return "Replace the artwork on " + who + "?\n\nOnly " + only + " replaced. Other locations stay as they are.";
  }

  function attachFiles(line, picked, results, btn, status) {
    var api = window.EZINKSizeQtyCart;
    var onCart = line.closest && line.closest("[data-ezink-cart-artwork]");
    if (onCart && api && typeof api.applyCartArtwork === "function") {
      var patches = cartArtworkPatches(line);
      if (!patches.length) {
        showStatus(status, "Choose a file or paste a cloud link for a location.", true);
        return;
      }
      var inPlace = artworkLocationsInPlace(line);
      var replacing = [];
      patches.forEach(function (patch) {
        if (!patch.file) return;
        var hit = inPlace[String(patch.loc || "").trim().toLowerCase()];
        if (hit && replacing.indexOf(hit) < 0) replacing.push(hit);
      });
      if (replacing.length && !window.confirm(replacementNotice(replacing))) return;
      btn.disabled = true;
      showStatus(status, replacing.length ? "Replacing artwork on " + replacing.join(", ") + "…" : "Adding artwork…", false);
      var setId = line.getAttribute("data-art-set") || line.getAttribute("data-key") || "";
      api.applyCartArtwork(setId, patches).catch(function (err) {
        btn.disabled = false;
        showStatus(status, (err && err.message) || "Could not update that location.", true);
      });
      return;
    }
    btn.disabled = true;
    showStatus(status, "Attaching…", false);
    var props = parseAttached(line);
    var artSet = line.getAttribute("data-art-set") || "";
    var wrap = line.querySelector("[data-ezink-art-items]");
    if (wrap) syncDecoration(wrap);
    var checkSummary = results.map(function (r) {
      return r.label + ": " + r.summary;
    }).join(" | ").slice(0, 900);

    function buildFd(variantId, qty) {
      var fd = new FormData();
      fd.append("id", String(variantId));
      fd.append("quantity", String(qty || "1"));
      Object.keys(props).forEach(function (key) {
        if (key.charAt(0) === "_") return;
        var replacing = picked.some(function (p) { return p.name === key; });
        if (replacing) return;
        fd.append("properties[" + key + "]", props[key]);
      });
      picked.forEach(function (p) {
        var key = p.name || "";
        if (key.indexOf("properties[") !== 0) key = "properties[" + key + "]";
        fd.append(key, p.file);
      });
      if (wrap) {
        wrap.querySelectorAll("[data-ezink-art-item]").forEach(function (item) {
          var loc = item.getAttribute("data-art-label") || locationBase(item);
          var size = sizeInches(item);
          if (size) fd.append("properties[Size — " + loc + "]", size.label);
          var tField = item.querySelector("[data-ezink-art-transfer-field]");
          if (tField && tField.value) fd.append("properties[Print type — " + loc + "]", tField.value);
          var linkEl = item.querySelector("[data-ezink-art-link]");
          var notesEl = item.querySelector("[data-ezink-art-notes]");
          if (linkEl && linkEl.value.trim()) {
            fd.append("properties[Artwork link — " + loc + "]", linkEl.value.trim());
          }
          if (notesEl && notesEl.value.trim()) {
            fd.append("properties[Artwork notes — " + loc + "]", notesEl.value.trim());
          }
        });
        var deco = wrap.querySelector("[data-ezink-decoration]");
        var map = wrap.querySelector("[data-ezink-art-map]");
        if (deco && deco.value) fd.append("properties[Decoration]", deco.value);
        if (map && map.value) fd.append("properties[_Artwork map]", map.value);
      }
      if (artSet) fd.append("properties[_Artwork set]", artSet);
      fd.append("properties[_Artwork check]", checkSummary);
      return fd;
    }

    function postAndReplace(variantId, qty, oldKey) {
      return fetch("/cart/add.js", {
        method: "POST",
        body: buildFd(variantId, qty),
        headers: { Accept: "application/json" }
      })
        .then(function (res) {
          return res.json().then(function (body) {
            if (!res.ok) throw new Error(body.description || body.message || "Upload failed");
            return body;
          });
        })
        .then(function () {
          return fetch("/cart/change.js", {
            method: "POST",
            headers: { "Content-Type": "application/json", Accept: "application/json" },
            body: JSON.stringify({ id: oldKey, quantity: 0 })
          });
        });
    }

    var jobs = [];
    if (artSet) {
      document.querySelectorAll("[data-cart-item][data-art-set]").forEach(function (el) {
        if (el.getAttribute("data-art-set") !== artSet) return;
        jobs.push({
          variant: el.getAttribute("data-cart-item-variant"),
          qty: el.getAttribute("data-cart-item-quantity") || "1",
          key: el.getAttribute("data-cart-item-key")
        });
      });
    }
    if (!jobs.length) {
      jobs.push({
        variant: line.getAttribute("data-variant"),
        qty: line.getAttribute("data-qty") || "1",
        key: line.getAttribute("data-key")
      });
    }

    var chain = Promise.resolve();
    jobs.forEach(function (job) {
      chain = chain.then(function () {
        return postAndReplace(job.variant, job.qty, job.key);
      });
    });
    chain
      .then(function () {
        window.location.reload();
      })
      .catch(function (err) {
        btn.disabled = false;
        showStatus(status, err.message || "Could not attach file.", true);
      });
  }

  document.addEventListener(
    "submit",
    function (evt) {
      var form = evt.target;
      if (!(form instanceof HTMLFormElement)) return;
      var pdp = form.querySelector("[data-ezink-art-pdp]");
      if (!pdp) return;

      var sizeQty = window.ezinkSizeQty;
      if (sizeQty && sizeQty.active(form)) return;
      var sizeLines = null;
      if (sizeLines && !sizeLines.length) {
        evt.preventDefault();
        evt.stopImmediatePropagation();
        window.alert("Enter a quantity for at least one size.");
        return;
      }

      var files = [];
      form.querySelectorAll('input[type="file"]').forEach(function (inp) {
        if (inp.hasAttribute("data-ezink-mockup-file")) return;
        if (inp.files && inp.files[0]) files.push(inp.files[0]);
      });
      var missingSize = [];
      pdp.querySelectorAll("[data-ezink-art-item]").forEach(function (item) {
        var inp = item.querySelector("[data-ezink-file]");
        if (inp && inp.files && inp.files[0] && !sizeInches(item)) {
          missingSize.push(item.getAttribute("data-art-label") || "a location");
        }
      });
      if (missingSize.length) {
        evt.preventDefault();
        evt.stopImmediatePropagation();
        window.alert("Enter a print size (W × H inches) for: " + missingSize.join(", ") + ".");
        return;
      }
      if (!files.length && !sizeLines) return;

      for (var i = 0; i < files.length; i++) {
        if (fileTooBig(files[i])) {
          evt.preventDefault();
          evt.stopImmediatePropagation();
          window.alert("Each file must be 20 MB or smaller. For larger files, paste a Drive, Dropbox, or WeTransfer link on that location instead.");
          return;
        }
      }

      evt.preventDefault();
      evt.stopImmediatePropagation();

      runInputPreviews(pdp).then(function (results) {
        if (results.some(function (r) { return Check.hasWarn(r.issues); })) {
          var lines = [];
          results.forEach(function (r) {
            r.issues.filter(function (i) { return i.level === "warn" || i.level === "error"; }).forEach(function (i) {
              lines.push(i.message);
            });
          });
          var go = window.confirm(
            "This artwork may be out of spec:\n\n• " +
              lines.join("\n• ") +
              "\n\nAdd to cart anyway? You can review it again before checkout. We proof every job."
          );
          if (!go) return;
        }
        var qtyInp = form.querySelector('[name="quantity"]');
        var qty = qtyInp ? parseInt(qtyInp.value, 10) : 1;
        if (sizeLines && sizeLines.length) {
          qty = 0;
          sizeLines.forEach(function (l) { qty += l.quantity; });
        }
        if (isNaN(qty) || qty < 1) qty = 1;

        var addGarments;
        if (sizeLines && sizeLines.length && window.ezinkSizeQty && typeof window.ezinkSizeQty.addToCart === "function") {
          addGarments = window.ezinkSizeQty.addToCart(form);
        } else {
          function addFormLine(variantId, quantity) {
            var fd = new FormData();
            fd.append("id", String(variantId));
            fd.append("quantity", String(quantity));
            Array.prototype.forEach.call(form.elements, function (el) {
              if (!el.name || el.disabled) return;
              if (el.name === "id" || el.name === "quantity" || el.name === "add") return;
              if (el.tagName === "BUTTON") return;
              if (el.type === "file") {
                if (el.files && el.files[0]) fd.append(el.name, el.files[0]);
                return;
              }
              if ((el.type === "checkbox" || el.type === "radio") && !el.checked) return;
              if (el.value) fd.append(el.name, el.value);
            });
            return fetch("/cart/add.js", {
              method: "POST",
              body: fd,
              headers: { Accept: "application/json" }
            }).then(function (res) {
              return res.json().then(function (body) {
                if (!res.ok) throw new Error(body.description || body.message || "Could not add to cart");
                return body;
              });
            });
          }

          if (sizeLines && sizeLines.length) {
            addGarments = Promise.resolve();
            sizeLines.forEach(function (line) {
              addGarments = addGarments.then(function () {
                return addFormLine(line.id, line.quantity);
              });
            });
          } else {
            addGarments = addFormLine(
              (form.querySelector('[name="id"]') || {}).value,
              qty
            );
          }

          addGarments = addGarments.then(function () {
            var extra = window.EZINKHtv && window.EZINKHtv.cartLines ? window.EZINKHtv.cartLines(qty, pdp) : [];
            var chain = Promise.resolve();
            extra.forEach(function (line) {
              chain = chain.then(function () {
                return fetch("/cart/add.js", {
                  method: "POST",
                  headers: { "Content-Type": "application/json", Accept: "application/json" },
                  body: JSON.stringify(line)
                }).then(function (res) {
                  return res.json().then(function (body) {
                    if (!res.ok) throw new Error(body.description || body.message || "Could not add decoration");
                  });
                });
              });
            });
            return chain;
          });
        }

        addGarments
          .then(function () {
            window.location.href = "/cart";
          })
          .catch(function (err) {
            window.alert(err.message || "Could not add to cart");
          });
      });
    },
    true
  );

  document.addEventListener("submit", function (evt) {
    var form = evt.target;
    if (!(form instanceof HTMLFormElement) || !form.classList.contains("cart")) return;
    var submitter = evt.submitter;
    if (submitter && submitter.getAttribute("name") !== "checkout") return;
    if (!form.querySelector("[data-ezink-cart-artwork]")) return;

    var lines = form.querySelectorAll("[data-ezink-line]");
    var missing = [];
    lines.forEach(function (line) {
      var attached = line.querySelector(".ezink-art__attached li");
      if (!attached) missing.push(line.getAttribute("data-title") || "an item");
    });
    var link = (form.querySelector("#ezink-cart-art-link") || {}).value || "";
    var later = form.querySelector('.ezink-art__later input[type="checkbox"]');
    var warnings = collectCheckoutWarnings(form);

    if (missing.length && !link.trim() && !(later && later.checked)) {
      var ok = window.confirm(
        "No artwork is attached for: " +
          missing.join(", ") +
          ".\n\nCheckout anyway? You can email files to orders@ez-ink.com with your order number."
      );
      if (!ok) {
        evt.preventDefault();
        return;
      }
    }
    if (warnings.length) {
      var go = window.confirm(
        "Please review your artwork before paying. We found possible spec issues:\n\n• " +
          warnings.slice(0, 6).join("\n• ") +
          "\n\nCheckout anyway? We proof every job and will contact you if we need a new file."
      );
      if (!go) evt.preventDefault();
    }
  });

  document.addEventListener("dragover", function (evt) {
    var drop = evt.target.closest && evt.target.closest(".ezink-art__drop");
    if (!drop || drop.hidden) return;
    evt.preventDefault();
    drop.classList.add("is-drag");
  });
  document.addEventListener("dragleave", function (evt) {
    var drop = evt.target.closest && evt.target.closest(".ezink-art__drop");
    if (!drop) return;
    drop.classList.remove("is-drag");
  });
  document.addEventListener("drop", function (evt) {
    var drop = evt.target.closest && evt.target.closest(".ezink-art__drop");
    if (!drop || drop.hidden) return;
    evt.preventDefault();
    drop.classList.remove("is-drag");
    var inp = drop.querySelector('input[type="file"]');
    var file = evt.dataTransfer && evt.dataTransfer.files && evt.dataTransfer.files[0];
    if (!inp || inp.disabled || !file) return;
    try {
      var dt = new DataTransfer();
      dt.items.add(file);
      inp.files = dt.files;
    } catch (err) {
      return;
    }
    inp.dispatchEvent(new Event("change", { bubbles: true }));
  });

  function resolveArtUrl(v) {
    v = String(v || "").trim();
    if (!v) return "";
    if (/^https?:\/\//i.test(v) || v.indexOf("//") === 0) return v;
    var packed = v.match(/^([0-9a-f]{32})[:/](.+)$/i);
    if (packed) return "https://custom.ez-ink.com/shopify/artwork/" + packed[1] + "/" + packed[2];
    if (/custom\.ez-ink\.com\//i.test(v) || /cdn\.shopify\.com\//i.test(v)) return "https://" + v.replace(/^\/+/, "");
    if (v.indexOf("/") >= 0 && v.indexOf(".") >= 0 && v.indexOf(" ") < 0) return "https://" + v.replace(/^\/+/, "");
    return "";
  }

  function isUploadUrl(v) {
    var s = String(v || "").toLowerCase();
    return /custom\.ez-ink\.com|cdn\.shopify\.com|\/shopify\/artwork\/|\/s\/files\//.test(s);
  }

  function isCloudUrl(v) {
    var s = String(v || "").toLowerCase();
    if (!s || /javascript:/i.test(s)) return false;
    if (isUploadUrl(s)) return false;
    return /drive\.google|dropbox\.com|wetransfer|\.we\.tl|box\.com|onedrive|1drv\.ms|icloud\.com|frame\.io/.test(s)
      || /^https?:\/\//i.test(s)
      || /^[a-z0-9.-]+\.[a-z]{2,}\//i.test(s);
  }

  function hrefForLink(v) {
    var u = resolveArtUrl(v) || String(v || "").trim();
    if (!u || /javascript:/i.test(u)) return "";
    if (/^https?:\/\//i.test(u)) return u;
    if (u.indexOf("//") === 0) return "https:" + u;
    if (/^[a-z0-9.-]+\.[a-z]{2,}([/:?]|$)/i.test(u)) return "https://" + u.replace(/^\/+/, "");
    return "";
  }

  function hostForLink(v) {
    var href = hrefForLink(v);
    try {
      return (href && new URL(href).hostname.replace(/^www\./, "")) || "Cloud link";
    } catch (err) {
      return "Cloud link";
    }
  }

  function placeCloudLink(copy, href, title) {
    if (!copy || !href) return;
    var line = copy.querySelector(".ezink-art__loc-cloudline");
    var link = copy.querySelector(".ezink-art__loc-cloud");
    if (!line) {
      line = document.createElement("span");
      line.className = "ezink-art__loc-cloudline";
      line.appendChild(document.createTextNode("LINK: "));
      if (!link) {
        link = document.createElement("a");
        link.className = "ezink-art__loc-cloud";
        link.target = "_blank";
        link.rel = "noopener";
      }
      line.appendChild(link);
      copy.appendChild(line);
    } else if (!link) {
      link = document.createElement("a");
      link.className = "ezink-art__loc-cloud";
      link.target = "_blank";
      link.rel = "noopener";
      line.appendChild(link);
    } else if (link.parentNode !== line) {
      line.appendChild(link);
    }
    link.href = href;
    var next = String(title || "").trim();
    if (!next) next = String(link.textContent || "").trim();
    if (!next || next === "Cloud link") next = hostForLink(href);
    link.textContent = next;
  }

  function syncCloudPreview(item) {
    var inp = item && item.querySelector("[data-ezink-art-link]");
    if (!inp) return;
    var href = hrefForLink(inp.value);
    var prev = item.querySelector(".ezink-art-item__cloud-preview");
    if (!href) {
      if (prev) prev.remove();
      return;
    }
    if (!prev) {
      prev = document.createElement("a");
      prev.className = "ezink-art-item__cloud-preview";
      prev.target = "_blank";
      prev.rel = "noopener";
      inp.parentNode.appendChild(prev);
    }
    prev.href = href;
    prev.textContent = hostForLink(href);
  }

  function artBlockParts(text) {
    var raw = String(text || "").replace(/\r\n/g, "\n").trim();
    var notes = "";
    var noteMatch = raw.match(/(?:^|\n)\s*Notes:\s*([\s\S]*)$/i) || raw.match(/\|\s*Notes:\s*([\s\S]*)$/i);
    if (noteMatch) {
      notes = String(noteMatch[1] || "").trim();
      raw = raw.slice(0, noteMatch.index).trim();
    }
    var urls = [];
    raw.split(/\n+|\s+\|\s+/).forEach(function (part) {
      var line = String(part || "").trim();
      var found = line.match(/https?:\/\/\S+/i);
      if (found) urls.push(found[0].replace(/[),.;]+$/, ""));
    });
    return { urls: urls, notes: notes };
  }

  function artLocHit(key, loc, slug) {
    if (!key || !loc) return false;
    if (key === "print | " + loc || key === slug) return true;
    function endsWithToken(value, token) {
      if (!token || value.length < token.length || value.slice(value.length - token.length) !== token) return false;
      if (value.length === token.length) return true;
      var prev = value.charAt(value.length - token.length - 1);
      return prev === " " || prev === "_" || prev === "|" || prev === "-" || prev === "—" || prev === "/";
    }
    if (endsWithToken(key, loc)) return true;
    if (slug && endsWithToken(key, slug)) return true;
    return false;
  }

  function artLocInText(val, loc) {
    var low = String(val || "").toLowerCase();
    var from = 0;
    while (from < low.length) {
      var at = low.indexOf(loc, from);
      if (at < 0) return false;
      if (!/^\s*\d/.test(low.slice(at + loc.length))) return true;
      from = at + loc.length;
    }
    return false;
  }

  function fillLocThumbs(line) {
    var blob = line.getAttribute("data-art-urls") || "";
    var urls = [];
    blob.split(";;").forEach(function (pair) {
      if (!pair) return;
      var i = pair.indexOf("||");
      if (i < 0) return;
      var k = pair.slice(0, i).toLowerCase();
      var v = pair.slice(i + 2);
      if (k === "_artfiles" || k === "artfiles") {
        v.split("|").forEach(function (bit) {
          var eq = bit.indexOf("=");
          if (eq < 0) return;
          urls.push({ k: bit.slice(0, eq).toLowerCase().trim(), v: bit.slice(eq + 1).trim() });
        });
        return;
      }
      urls.push({ k: k, v: v });
    });
    line.querySelectorAll(".ezink-art__loc-card").forEach(function (card) {
      var loc = (card.getAttribute("data-loc") || "").toLowerCase();
      var slug = loc.replace(/[^a-z0-9]+/g, "_").replace(/^_|_$/g, "");
      var thumb = card.querySelector(".ezink-art__loc-thumb");
      var copy = card.querySelector(".ezink-art__loc-copy");
      if (!loc || !thumb) return;
      var hit = resolveArtUrl(thumb.getAttribute("data-preview") || "");
      var cloud = "";
      var notes = "";
      if (!hit && copy) {
        var copyText = copy.textContent || "";
        var ez = copyText.match(/ezart:([0-9a-f]{32}[:/][^\s]+)/i);
        var elink = copyText.match(/ezlink:([^\s]+)/i);
        if (ez) hit = resolveArtUrl(ez[1]);
        else if (elink) cloud = elink[1];
      }
      urls.forEach(function (u) {
        var key = String(u.k || "");
        var val = String(u.v || "");
        var locHit = artLocHit(key, loc, slug);
        var decoHit = val.match(new RegExp("ezart:([0-9a-f]{32}[:/][^\\s]+)", "i"));
        var decoLink = val.match(/ezlink:([^\s]+)/i);
        if ((key === "decoration" || key === "_decoration" || key === "artwork locations" || key === "_artwork locations") && artLocInText(val, loc)) {
          if (decoHit && !hit) hit = resolveArtUrl(decoHit[1]);
          if (decoLink && !cloud) cloud = decoLink[1];
        }
        if ((key.indexOf("print | ") === 0 || key.indexOf("_print | ") === 0) && locHit) {
          var parsed = artBlockParts(val);
          if (parsed.notes && !notes) notes = parsed.notes;
          parsed.urls.forEach(function (url) {
            var parsedUrl = resolveArtUrl(url);
            if (parsedUrl && isUploadUrl(parsedUrl)) {
              if (!hit || /cdn\.shopify\.com/i.test(hit)) hit = parsedUrl;
            } else if (parsedUrl && isCloudUrl(parsedUrl) && !cloud) cloud = parsedUrl;
          });
          return;
        }
        if (!locHit) return;
        if (key.indexOf("artwork notes") === 0 && val && !notes) notes = val;
        if ((key.indexOf("artwork link") === 0 || key.indexOf("_artlink_") === 0) && val && !cloud) cloud = val;
        var resolved = resolveArtUrl(val);
        if (resolved && /\s/.test(resolved)) resolved = "";
        if (resolved && isUploadUrl(resolved) && !hit) hit = resolved;
        else if (resolved && isCloudUrl(resolved) && !cloud) cloud = resolved;
      });
      if (hit && /\s/.test(hit)) hit = "";
      if (hit && isCloudUrl(hit) && !isUploadUrl(hit)) {
        if (!cloud) cloud = hit;
        hit = "";
      }
      var cloudHref = hrefForLink(cloud);
      thumb.removeAttribute("data-ezink-open-preview");
      thumb.removeAttribute("data-preview");
      if (hit) {
        thumb.classList.remove("is-empty");
        var img = thumb.querySelector("img");
        if (!img && /\.(png|jpe?g|gif|webp|svg)(\?|$)/i.test(hit)) {
          img = document.createElement("img");
          img.alt = loc + " artwork";
          thumb.innerHTML = "";
          thumb.appendChild(img);
        } else if (!img && !thumb.querySelector(".ezink-art__loc-ext")) {
          thumb.innerHTML = '<span class="ezink-art__loc-ext">FILE</span>';
        }
        if (img) {
          img.src = hit;
          img.style.cssText = "width:72px;height:72px;object-fit:contain;object-position:center;display:block;max-width:72px;max-height:72px";
        }
      } else {
        var linkBadge = thumb.querySelector(".ezink-art__loc-ext");
        if (linkBadge && String(linkBadge.textContent || "").trim() === "LINK") linkBadge.remove();
      }
      if (copy) {
        var oldLink = copy.querySelector(".ezink-art__loc-link");
        if (oldLink) {
          var span = document.createElement("span");
          span.className = "ezink-art__loc-label";
          span.textContent = oldLink.textContent || "";
          oldLink.replaceWith(span);
        }
        var cloudTitle = "";
        var fileEl = copy.querySelector(".ezink-art__loc-file");
        var extEl = thumb.querySelector(".ezink-art__loc-ext");
        var hasUpload = !!(thumb.querySelector("img") || (extEl && String(extEl.textContent || "").trim() !== "LINK"));
        if (fileEl && !hasUpload) {
          cloudTitle = String(fileEl.textContent || "").trim();
          fileEl.remove();
        }
        var existingCloud = copy.querySelector(".ezink-art__loc-cloud");
        var existingHref = existingCloud && existingCloud.getAttribute("href");
        if (cloudHref && !existingHref) placeCloudLink(copy, cloudHref, cloudTitle);
        else if (existingCloud && cloudTitle && !String(existingCloud.textContent || "").trim()) existingCloud.textContent = cloudTitle;
      }
      if (notes && !card.querySelector(".ezink-art__loc-notes")) {
        var np = document.createElement("p");
        np.className = "ezink-art__loc-notes";
        np.textContent = notes;
        card.appendChild(np);
      }
    });
  }

  function onPdpQtyRefresh(evt) {
    var t = evt && evt.target;
    if (!t || !t.closest) return;
    if (!t.closest("[data-ezink-size-qty]")) return;
    refreshAllPrintTypes();
  }
  document.addEventListener("input", onPdpQtyRefresh, true);
  document.addEventListener("keyup", onPdpQtyRefresh, true);
  document.addEventListener("change", onPdpQtyRefresh, true);
  document.addEventListener("ezink-size-qty-rebuilt", function () {
    watchQtyTotals();
    refreshAllPrintTypes();
  });
  watchQtyTotals();

  function watchQtyTotals() {
    document.querySelectorAll("[data-ezink-size-qty-total]").forEach(function (el) {
      if (el.getAttribute("data-ezink-print-watch") === "1") return;
      el.setAttribute("data-ezink-print-watch", "1");
      var last = el.textContent;
      var mo = new MutationObserver(function () {
        if (el.textContent === last) return;
        last = el.textContent;
        refreshAllPrintTypes();
      });
      mo.observe(el, { childList: true, characterData: true, subtree: true });
    });
  }

  document.addEventListener("change", function (evt) {
    var sel = evt.target && evt.target.closest && evt.target.closest("[data-ezink-print-opt]");
    if (!sel) return;
    var root = sel.closest("[data-ezink-art-pdp]") || document.querySelector("[data-ezink-art-pdp]");
    var wrap = root && root.querySelector("[data-ezink-art-items]");
    if (wrap) syncPrintArtSlots(wrap);
  });

  document.addEventListener("DOMContentLoaded", function () {
    watchQtyTotals();
    applyQuoteState();
    document.querySelectorAll("[data-ezink-art-pdp], [data-ezink-line]").forEach(function (root) {
      initArtItems(root);
      var wrap = root.querySelector("[data-ezink-art-items]") || (root.matches && root.matches("[data-ezink-art-items]") ? root : null);
      if (wrap) refreshTransferSelects(wrap);
    });
    document.querySelectorAll("[data-ezink-line]").forEach(function (line) {
      fillLocThumbs(line);
      runAttachedPreviews(line);
    });
  });
})();

(function () {
  var priceById = {};
  var loaded = {};

  function formatMoney(cents, moneyFormat) {
    cents = Math.round(Number(cents) || 0);
    var dollars = (Math.abs(cents) / 100).toFixed(2);
    var formatted = (moneyFormat || "${{amount}}")
      .replace(/\{\{\s*amount_no_decimals\s*\}\}/g, String(Math.round(Math.abs(cents) / 100)))
      .replace(/\{\{\s*amount_with_comma_separator\s*\}\}/g, dollars.replace(".", ","))
      .replace(/\{\{\s*amount\s*\}\}/g, dollars);
    if (formatted === moneyFormat) formatted = "$" + dollars;
    return (cents < 0 ? "-" : "") + formatted;
  }

  function decoEach(qty, root) {
    try {
      var pdp = root.querySelector("[data-ezink-art-pdp]") || root;
      if (window.EZINKHtv && typeof window.EZINKHtv.extraEachCents === "function") {
        return Number(window.EZINKHtv.extraEachCents(qty)) || 0;
      }
    } catch (err) {}
    return 0;
  }

  function seedPricesFromDom(root) {
    if (!root) return;
    var sid = root.getAttribute("data-section-id");
    var el = (sid && document.getElementById("VariantInventoryJson-" + sid)) ||
      document.querySelector('[id^="VariantInventoryJson-"]');
    if (el) {
      try {
        var data = JSON.parse((el.textContent || "").trim() || "{}");
        var prices = data && data.price;
        if (prices && typeof prices === "object") {
          Object.keys(prices).forEach(function (k) {
            if (priceById[String(k)] != null) return;
            var n = parseInt(prices[k], 10);
            if (!isNaN(n) && n > 0) priceById[String(k)] = n;
          });
        }
      } catch (eInv) {}
    }
    var pj = sid ? document.getElementById("ProductJson-" + sid) : document.querySelector('[id^="ProductJson-"]');
    if (pj) {
      try {
        var prod = JSON.parse((pj.textContent || "").trim() || "{}");
        (prod.variants || []).forEach(function (v) {
          if (v && v.id != null && v.price != null && priceById[String(v.id)] == null) {
            priceById[String(v.id)] = v.price;
          }
        });
      } catch (ePj) {}
    }
  }

  function displayedUnit(root) {
    var hook = root.querySelector("[data-sale-price]") || root.querySelector("[data-regular-price]");
    if (!hook) return 0;
    var raw = (hook.textContent || "").replace(/[^0-9.]/g, "");
    var n = parseFloat(raw);
    if (!isNaN(n) && n > 0) return Math.round(n * 100);
    return 0;
  }

  function unitFromInput(inp, root) {
    var attr = inp.getAttribute("data-price");
    if (attr != null && attr !== "") {
      var fromAttr = parseInt(attr, 10);
      if (!isNaN(fromAttr) && fromAttr > 0) return fromAttr;
    }
    var id = inp.getAttribute("data-variant-id");
    if (id != null && id !== "") {
      if (priceById[String(id)] != null) return priceById[String(id)];
      if (priceById[id] != null) return priceById[id];
    }
    return displayedUnit(root);
  }

  function paint(root) {
    if (!root) return;
    seedPricesFromDom(root);
    try { paintPriceTiers(root); } catch (eTiers0) {}
    var grid = root.querySelector("[data-ezink-size-qty-grid]");
    if (!grid) return;
    var qty = 0;
    var garmentTotal = 0;
    var bits = [];
    var fallback = displayedUnit(root);
    grid.querySelectorAll("[data-ezink-size-qty-input]").forEach(function (inp) {
      if (inp.disabled) return;
      var n = parseInt(inp.value, 10) || 0;
      if (n < 1) return;
      qty += n;
      var unit = unitFromInput(inp, root) || fallback;
      garmentTotal += unit * n;
      var size = inp.getAttribute("data-size");
      if (size) bits.push(size + " × " + n);
    });
    var totEl = root.querySelector("[data-ezink-size-qty-total]");
    if (totEl) {
      totEl.hidden = false;
      totEl.removeAttribute("hidden");
      var strong = totEl.querySelector("strong");
      if (strong) strong.textContent = String(qty);
      else totEl.innerHTML = "Total qty: <strong>" + qty + "</strong>";
    }
    var hiddenQty = root.querySelector("[data-ezink-qty-input]");
    if (hiddenQty) hiddenQty.value = String(qty);
    var wrap = root.querySelector("[data-ezink-price-wrap]");
    var moneyFormat = (wrap && wrap.getAttribute("data-money-format")) || "${{amount}}";
    var selectedId = String((root.querySelector("[name='id']") || {}).value || "");
    var listEach = qty > 0
      ? Math.round(garmentTotal / qty)
      : (priceById[selectedId] || fallback || 0);
    if (window.EZINKHtv && typeof window.EZINKHtv.garmentCents === "function") {
      if (qty > 0) garmentTotal = window.EZINKHtv.garmentCents(garmentTotal, qty, root);
      listEach = window.EZINKHtv.garmentCents(listEach, qty > 0 ? qty : 1, root);
    }
    var garmentEach = listEach;
    var artDeco = decoEach(qty > 0 ? qty : 1, root);
    var hasArt = artDeco > 0;
    var fromDeco = 111;
    try {
      if (window.EZINKHtv && typeof window.EZINKHtv.startingDecoCents === "function") {
        fromDeco = window.EZINKHtv.startingDecoCents() || fromDeco;
      }
    } catch (eFrom) {}
    var deco = hasArt ? artDeco : fromDeco;
    var fee = 0;
    try {
      if (window.EZINKHtv && typeof window.EZINKHtv.lowQtyFeeCents === "function") {
        fee = window.EZINKHtv.lowQtyFeeCents(qty > 0 ? qty : 0) || 0;
      }
    } catch (eFee) {}
    var quoted = qty > 0 && hasArt;
    var total = quoted ? garmentTotal + deco * qty + fee : garmentEach + deco;
    var unit = quoted && qty > 0 ? Math.round(total / qty) : garmentEach + deco;
    document.querySelectorAll("[data-ezink-price-total]").forEach(function (el) {
      el.textContent = formatMoney(total, moneyFormat);
    });
    document.querySelectorAll("[data-ezink-price-unit]").forEach(function (el) {
      el.textContent = quoted
        ? "(" + formatMoney(unit, moneyFormat) + " each)"
        : "(from " + formatMoney(unit, moneyFormat) + " each)";
    });
    var note = root.querySelector("[data-ezink-price-note]");
    if (note) {
      var parts = [];
      if (qty > 0) parts.push(qty + " pc" + (qty === 1 ? "" : "s"));
      if (bits.length) parts.push(bits.join(", "));
      if (quoted && fee > 0) parts.push("$5 low-quantity fee");
      note.hidden = !parts.length;
      note.textContent = parts.join(" · ");
    }
    try {
      if (typeof window.ezinkApplyQuoteState === "function") window.ezinkApplyQuoteState(qty);
    } catch (eQuote) {}
    try { paintPriceTiers(root); } catch (eTiers) {}
  }

  var lastTierSig = "";

  function garmentForTiers(root) {
    seedPricesFromDom(root);
    var grid = root.querySelector("[data-ezink-size-qty-grid]");
    var qty = 0;
    var garmentTotal = 0;
    var min = 0;
    var fallback = displayedUnit(root);
    if (grid) {
      grid.querySelectorAll("[data-ezink-size-qty-input]").forEach(function (inp) {
        if (inp.disabled) return;
        var unit = unitFromInput(inp, root) || fallback;
        if (unit > 0 && (min === 0 || unit < min)) min = unit;
        var n = parseInt(inp.value, 10) || 0;
        if (n < 1) return;
        qty += n;
        garmentTotal += unit * n;
      });
    }
    if (qty > 0) return Math.round(garmentTotal / qty);
    if (min > 0) return min;
    var selectedId = String((root.querySelector("[name='id']") || {}).value || "");
    return priceById[selectedId] || fallback || 0;
  }

  function currentQtyForTiers(root) {
    var grid = root.querySelector("[data-ezink-size-qty-grid]");
    var qty = 0;
    if (grid) {
      grid.querySelectorAll("[data-ezink-size-qty-input]").forEach(function (inp) {
        if (inp.disabled) return;
        qty += parseInt(inp.value, 10) || 0;
      });
      return qty;
    }
    var input = root.querySelector("[data-ezink-qty-input]");
    var n = parseInt(input && input.value, 10);
    return isNaN(n) || n < 0 ? 0 : n;
  }

  function paintPriceTiers(root) {
    var el = document.querySelector("[data-ezink-price-tiers]");
    if (!el || !window.EZINKHtv || typeof window.EZINKHtv.estimateTiers !== "function") return;
    root = root || document.querySelector("[data-section-type='product']") || document.body;
    var moneyFormat = el.getAttribute("data-money-format") || "${{amount}}";
    var garment = garmentForTiers(root);
    if (!garment) {
      var seed = parseInt(el.getAttribute("data-garment-cents"), 10);
      if (!isNaN(seed) && seed > 0) garment = seed;
    }
    var qty = currentQtyForTiers(root);
    var hasArt = document.querySelectorAll(
      "[data-ezink-art-pdp][data-ezink-art-mode='apparel'] [data-ezink-art-item]"
    ).length > 0;
    var art = decoEach(qty > 0 ? qty : 1, root);
    el.classList.toggle("is-pending", !(qty > 0 && hasArt));
    var pending = el.querySelector("[data-ezink-tiers-pending]");
    if (pending) {
      if (!hasArt) pending.textContent = "Add an artwork location to see estimated prices.";
      else if (qty < 1) pending.textContent = "Enter sizes & qty to see estimated prices.";
    }
    if (!(qty > 0 && hasArt)) {
      lastTierSig = "";
      return;
    }
    var sig = [garment, qty, art].join(":");
    if (sig === lastTierSig && el.querySelector("[data-ezink-tier-row]")) return;
    lastTierSig = sig;
    var rows = window.EZINKHtv.estimateTiers(garment, root);
    var body = el.querySelector("[data-ezink-tiers-body]");
    if (!body) return;
    body.textContent = "";
    var activeQty = 0;
    if (qty > 0) {
      for (var i = 0; i < rows.length; i++) {
        if (qty >= rows[i].qty) activeQty = rows[i].qty;
      }
    }
    rows.forEach(function (row) {
      var tr = document.createElement("tr");
      tr.setAttribute("data-ezink-tier-row", String(row.qty));
      if (row.qty === activeQty) {
        tr.className = "is-active";
        tr.setAttribute("aria-current", "true");
      }
      var tdQ = document.createElement("td");
      tdQ.textContent = row.qty + "+";
      var tdE = document.createElement("td");
      tdE.textContent = formatMoney(row.each, moneyFormat);
      tr.appendChild(tdQ);
      tr.appendChild(tdE);
      body.appendChild(tr);
    });
    var nextEl = el.querySelector("[data-ezink-tiers-next]");
    if (nextEl) {
      var next = null;
      if (qty > 0) {
        for (var n = 0; n < rows.length; n++) {
          if (rows[n].qty > qty) {
            next = rows[n];
            break;
          }
        }
      }
      if (next) {
        nextEl.hidden = false;
        nextEl.textContent =
          "Add " + (next.qty - qty) + " more for " + formatMoney(next.each, moneyFormat) + " each (" + next.qty + "+).";
      } else {
        nextEl.hidden = true;
        nextEl.textContent = "";
      }
    }
    var hint = el.querySelector("[data-ezink-tiers-hint]");
    if (hint) {
      hint.textContent = art > 0
        ? "Using your artwork location(s). Print size and type change this table."
        : "One print location. Under 10 pieces uses DTF and a $5 low-quantity fee; 10+ uses 1 Color (smallest print) unless you pick another type.";
    }
  }
  window.ezinkPaintPriceTiers = paintPriceTiers;

  function loadPrices(root) {
    seedPricesFromDom(root);
    var handle = root.getAttribute("data-product-handle");
    if (!handle || loaded[handle]) {
      paint(root);
      return;
    }
    loaded[handle] = true;
    fetch("/products/" + encodeURIComponent(handle) + ".js", { credentials: "same-origin" })
      .then(function (res) { return res.ok ? res.json() : null; })
      .then(function (prod) {
        if (prod && prod.variants) {
          prod.variants.forEach(function (v) {
            if (v && v.id != null) priceById[String(v.id)] = v.price;
          });
        }
        paint(root);
      })
      .catch(function () { paint(root); });
  }

  function onQtyEdit(evt) {
    var t = evt.target;
    if (!t || !t.getAttribute || t.getAttribute("data-ezink-size-qty-input") == null) {
      if (!t || !t.closest || !t.closest("[data-ezink-size-qty-input]")) return;
    }
    var root = t.closest("[data-section-type='product']") || t.closest("[id^='ProductSection-']") ||
      document.querySelector("[data-section-type='product']");
    if (root) {
      loadPrices(root);
      paint(root);
    }
    if (typeof window.ezinkRefreshPrintTypes === "function") window.ezinkRefreshPrintTypes();
  }

  document.addEventListener("input", onQtyEdit, true);
  document.addEventListener("keyup", onQtyEdit, true);
  document.addEventListener("change", onQtyEdit, true);
  document.addEventListener("ezink-art-items-change", function (e) {
    var from = e && e.detail && e.detail.root;
    var root = (from && (from.closest("[data-section-type='product']") || from.closest("[id^='ProductSection-']"))) ||
      document.querySelector("[data-section-type='product']");
    if (root) {
      loadPrices(root);
      paint(root);
    }
    if (typeof window.ezinkUpdatePdpPrice === "function") window.ezinkUpdatePdpPrice();
  });
  document.addEventListener("DOMContentLoaded", function () {
    document.querySelectorAll("[data-ezink-size-qty-grid]").forEach(function (grid) {
      var root = grid.closest("[data-section-type='product']") || grid.closest("[id^='ProductSection-']");
      if (root) loadPrices(root);
    });
    paintPriceTiers();
  });
  paintPriceTiers();
  setTimeout(paintPriceTiers, 0);
  setTimeout(paintPriceTiers, 250);
})();
